import { DashboardCard } from "../../../components_new/dashboard-card/dashboard-card";
import { useContext } from "react";
import { reOrderReporting } from "../../../common/generic_functions";
import { ReportingContext } from "../../home/home";



export const DashboardCardList = ({ reportings, loadReports, optionsWorksTag, setLoading, setShowSuccessAlert }) => {
  const { getFavReports } = useContext(ReportingContext);
  const sortedReports = reOrderReporting(getFavReports(), reportings)

  if (!sortedReports || sortedReports.length === +0) {

    return <h1>No Dashboards available!</h1>;
  }

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", justifyContent: "flex-start" }}>
      {sortedReports.map((r, idx) => (
        <DashboardCard {...r} setShowSuccessAlert={setShowSuccessAlert} key={idx} loadReports={loadReports} optionsWorksTag={optionsWorksTag} setLoading={setLoading}/>
      ))}
    </div>
  );
};
